export default {
  SET_HIDDEN_BUTTON_SAVE: (state, hiddenButton) => {
    state.hiddenSaveButton = hiddenButton;
  },
  SET_IS_LOADING: (state, isLoading) => {
    state.isLoading = isLoading
  }
};
